import axios from 'axios'
import { message } from 'antd';

const put = async (url, data) => {
    const result = await axios.put(url, data);
    if (result.status == 200) {
        message.success("İşlem başarılı.")
    }
    return result;
};

export default put;